import { getApiClient, initializeApiClient } from "../../apiService";

export const AddExperienceSummary = async (
  projectName,
  briefDescriptionOfProject,
  yearOfImplementation,
  durationOfImplementationInMonths,
  countryWhereProjectWasImplemented,
  governorateRegion,
  nameOfProjectDonor,
  amountOfSupportReceived,
  contactPersonFromDonorOrganizationName,
  contactInformationEmailPhone,
  tE_TeamMembersPreviousExperiencePartnershipsId
) => {
  await initializeApiClient();
  const apiClient = await getApiClient();
  const response = await apiClient.post(
    `/api/TE_PreviousExperienceSummary/AddTE_PreviousExperienceSummaryData`,
    {
      projectName: projectName,
      briefDescriptionOfProject: briefDescriptionOfProject,
      yearOfImplementation: yearOfImplementation,
      durationOfImplementationInMonths: durationOfImplementationInMonths,
      countryWhereProjectWasImplemented: countryWhereProjectWasImplemented,
      governorateRegion: governorateRegion,
      nameOfProjectDonor: nameOfProjectDonor,
      amountOfSupportReceived: amountOfSupportReceived,
      contactPersonFromDonorOrganizationName:
        contactPersonFromDonorOrganizationName,
      contactInformationEmailPhone: contactInformationEmailPhone,
      tE_TeamMembersPreviousExperiencePartnershipsId:
        tE_TeamMembersPreviousExperiencePartnershipsId,
    }
  );

  return response;
};

export default AddExperienceSummary;
